export default "__VITE_ASSET__BbubRj22__"